import { useEffect, useRef } from "preact/hooks";
import { defineMessages, useT } from "../i18n/index.ts";

const messages = defineMessages(
  {
    title: "Lecture sur un autre appareil",
    text: "Sur un autre appareil, vous en êtes à {there} %. Ici, vous en êtes à {here} %.",
    goThere: "Aller à {there} %",
    stayHere: "Rester ici",
  },
  {
    title: "Reading on another device",
    text: "On another device, you're at {there}%. Here, you're at {here}%.",
    goThere: "Go to {there}%",
    stayHere: "Stay here",
  },
);

interface Props {
  /** Avancement (0 à 100) sur l'autre appareil, et ici. */
  there: number;
  here: number;
  onGo(): void;
  onStay(): void;
}

/** Popup centrée à l'ouverture d'un livre : un autre appareil a lu plus loin ou ailleurs, au lecteur de choisir. */
export function ElsewhereDialog({ there, here, onGo, onStay }: Props) {
  const t = useT(messages);
  const panel = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onStay();
    };
    window.addEventListener("keydown", onKey);
    panel.current?.focus();
    return () => window.removeEventListener("keydown", onKey);
  }, [onStay]);

  return (
    <div class="msb-popover-layer msb-elsewhere-layer">
      <div class="msb-popover-scrim" onClick={onStay} />
      <div ref={panel} class="msb-popover msb-elsewhere" role="dialog" aria-modal="true" aria-label={t("title")} tabIndex={-1}>
        <div class="msb-elsewhere__body">
          <h2>{t("title")}</h2>
          <p>{t("text", { there, here })}</p>
          <div class="msb-elsewhere__actions">
            <button type="button" class="reader-button reader-button--primary" onClick={onGo}>
              {t("goThere", { there })}
            </button>
            <button type="button" class="reader-button" onClick={onStay}>
              {t("stayHere")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
